import { CIRCLE_PREFIX_ID } from '@frontend/constants/templates-field-prefixes';
import { PRIMARY_MODE, SECONDARY_MODE } from '@frontend/group/modules/dominant-colors';
import { scaleControlsCornerSize } from '@frontend/constants/fabric-constants';
import { getPrimarySecondaryColorFromTheme, isInGroup } from '@frontend/utils';
import { ShowPageScopeCollector } from '@frontend/group/modules/scope-collectors/show-page-collector';
import {ThemesContainerSingleton} from "@/banner_template/themes/ThemesContainerSinglton";
import { getGroupNameByAddFieldId } from "@/common/preview/draw-smart-object";
import { FIELD_TYPE_SMART_OBJECT } from "@frontend/constants/type-fields-of-template";

const getScopePage = () => ShowPageScopeCollector.get(['canvas_data']);

export async function drawCircle({
   fields,
   data,
   canvas,
   id,
   group_fields,
   dimension,
   themes
}) {
  canvas.getObjects().forEach(function (o) {
    if (o.id.includes(CIRCLE_PREFIX_ID)) {
      canvas.remove(o);
    }
  });

  const { canvas_data } = getScopePage();

  canvas_data[id].circleCoords = [];

  const selectedTheme = await ThemesContainerSingleton.getThemeById(data?.theme);

  let index = 0;
  fields.forEach((field) => {
    const options = JSON.parse(field.options);
    const groupName = getGroupNameByAddFieldId(
      String(field.id),
      canvas_data[id]
    );

    if (field.type === 'Circle' && (!group_fields || isInGroup(group_fields, field.name))) {
      let fill_color = data[`${field.element_id}_fill_color`];
      let stroke_color = data[`${field.element_id}_stroke_color`];

      /* This logic is to overrride the automatic color from the product images on feed import */
      if (options['Option3'] === PRIMARY_MODE || options['Option3'] === SECONDARY_MODE) {
        const theme_fill_color = getPrimarySecondaryColorFromTheme(options['Option3'], selectedTheme);
        // if a color was found on the theme then use it, otherwise keep the previously saved color
        if (theme_fill_color !== options['Option3']) {
          fill_color = theme_fill_color;
        }
      }

      if (options['Option1'] === PRIMARY_MODE || options['Option1'] === SECONDARY_MODE) {
        const theme_stroke_color = getPrimarySecondaryColorFromTheme(options['Option1'], selectedTheme);
        // if a color was found on the theme then use it, otherwise keep the previously saved color
        if (theme_stroke_color !== options['Option1']) {
          stroke_color = theme_stroke_color;
        }
      }

      const width = +data[`${field.element_id}_width`] || +options['Width'];
      const height = +data[`${field.element_id}_height`] || +options['Height'];
      const scaleX = parseFloat(data[`${field.element_id}_scaleX`]);
      const scaleY = parseFloat(data[`${field.element_id}_scaleY`]);
      const radius = parseFloat(data[`${field.element_id}_radius`]) || width / 2 || 150;
      const offset_x = data[`${field.element_id}_offset_x`];
      const offset_y = data[`${field.element_id}_offset_y`];
      const opacity = data[`${field.element_id}_opacity`] ?? 1;
      const thickness = parseInt(data[`${field.element_id}_thickness`]);
      const toggleShape =
        options['Color Selector'] === 'No' || data[`${field.element_id}_toggle_shape`] === undefined ||
        (data[`${field.element_id}_toggle_shape`] && data[`${field.element_id}_toggle_shape`] === 'on');
      const visible = data[`${field.element_id}_visible`] ?? !options['Hidden'];

      if (!toggleShape) return;

      const circle = new fabric.Ellipse({
        id: CIRCLE_PREFIX_ID + index,
        groupName: groupName,
        order: parseInt(options['Order']),
        top: parseInt(options['Y']) + parseFloat(offset_y),
        left: canvas_data[id].spacingFieldPosition[field.name]
          ? canvas_data[id].spacingFieldPosition[field.name].x
          : parseInt(options['X']) + parseFloat(offset_x),
        rx: width / 2,
        ry: height / 2,
        radius: radius,
        fill: fill_color
          ? fill_color
          : options['Option3']
            ? options['Option3']
            : '#ffffff',
        stroke: stroke_color
          ? stroke_color
          : options['Option1']
            ? options['Option1']
            : '#ffffff',
        strokeWidth: thickness ? thickness : (options['Option2'] ? parseInt(options['Option2']) : 1),
        opacity,
        selectable: true,
        evented: true,
        fieldId: +options['id'],
        element_id: field.element_id,
        scaleX,
        scaleY,
        templateField: canvas_data[id].templateInstance.getFieldById(+options['id']),
        visible
      });

      circle.setControlsVisibility({
        tl: true,
        tr: true,
        br: true,
        bl: true,
        ml: true,
        mt: true,
        mr: true,
        mb: true,
        mtr: true,
      });

      let group_x = 0, group_y = 0;

      if (groupName !== '' && canvas_data[id].smartObjCoords[groupName]) {
        group_x = parseInt(canvas_data[id].smartObjCoords[groupName]['X']);
        group_y = parseInt(canvas_data[id].smartObjCoords[groupName]['Y']);
      }

      circle.set({
        left: circle.left + group_x - dimension[2] + dimension[4].x,
        top: circle.top + group_y - dimension[3] + dimension[4].y,
      });
      
      scaleControlsCornerSize(circle);
      
      canvas.add(circle);

      canvas_data[id].circleCoords.push({
        x: parseInt(options['X']) + group_x,
        y: parseInt(options['Y']) + group_y,
        scaleX: circle.scaleX / scaleX,
      });

      index++;
    }
  });
}
